export const MOBILE_MAIN_TAB_HEIGHT_PX = 44;
export const PC_MAIN_TAB_HEIGHT_PX = 106;
